import { SectionHeader } from "./SectionHeader";
import type { Theme } from "./theme";

const PILLARS = [
  {
    t: "executive search methodology",
    d: "The structure behind retained search, internalised.",
  },
  {
    t: "occupational psychology",
    d: "Evidence-based frameworks for assessing people.",
  },
  {
    t: "structured, evidence-based evaluation",
    d: "Repeatable decision quality across stakeholders.",
  },
];

export function Credibility({ theme }: { theme: Theme }) {
  return (
    <section
      style={{
        padding: "120px 0",
        borderTop: `1px solid ${theme.border}`,
        background: theme.surface,
      }}
    >
      <SectionHeader theme={theme} kicker="Credibility" title="Grounded in real hiring practice." />
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 40px" }}>
        <p
          style={{
            fontSize: 17,
            color: theme.fgMute,
            lineHeight: 1.6,
            maxWidth: 720,
            marginBottom: 48,
          }}
        >
          Rarion is built on:
        </p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 24,
          }}
        >
          {PILLARS.map((p, i) => (
            <div
              key={p.t}
              style={{
                padding: "24px 0 24px",
                borderTop: `2px solid ${theme.accent}`,
              }}
            >
              <div
                style={{
                  fontFamily: theme.mono,
                  fontSize: 11,
                  color: theme.fgMute,
                  marginBottom: 12,
                  letterSpacing: 0.5,
                }}
              >
                0{i + 1}
              </div>
              <div
                style={{
                  fontSize: 22,
                  fontWeight: 600,
                  color: theme.fg,
                  letterSpacing: -0.5,
                  lineHeight: 1.2,
                  marginBottom: 12,
                }}
              >
                {p.t}
              </div>
              <div style={{ fontSize: 14, color: theme.fgMute, lineHeight: 1.55 }}>{p.d}</div>
            </div>
          ))}
        </div>
        <p
          style={{
            fontSize: 15,
            color: theme.fgMute,
            lineHeight: 1.6,
            maxWidth: 720,
            marginTop: 48,
            fontStyle: "italic",
          }}
        >
          It reflects how experienced hiring professionals approach complex hiring decisions,
          translated into a system that can be applied consistently across an organisation.
        </p>
      </div>
    </section>
  );
}
